import { render, staticRenderFns } from "./TotalGovContribution.vue?vue&type=template&id=f2a2c692&scoped=true"
import script from "./TotalGovContribution.vue?vue&type=script&lang=js"
export * from "./TotalGovContribution.vue?vue&type=script&lang=js"
import style0 from "./TotalGovContribution.vue?vue&type=style&index=0&id=f2a2c692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2c692",
  null
  
)

export default component.exports